<div class="tag-picker-container" [ngClass]="{'tag-picker-container-full' : mode === 'full'}">

    <!-- wyszikiwanie i wprowadzanie-->
    <div class="block" [ngClass]="{'block-with-entry-visible' : isEntryVisible}">

        <div class="input-block">

            <!-- nagłówek -->
            <div *ngIf="!isEntryVisible" class="icon"></div>
            <div *ngIf="isEntryVisible" class="icon-blue"></div>
            <div class="text">{{'tags.label' | translate}}</div>

            <!-- gdy panel wprowadzania tagów niewidoczny -->
            <div *ngIf="!isEntryVisible" class="entry-hidden">

                <!-- wyświetlanie -->
                <div class="show">
                    <a *ngIf="!this.isLoading" class="link" (click)="showEntry()">{{'labels.select' | translate}}</a>
                    <span *ngIf="this.isLoading" style="font-size: 1.1em;">{{'tags.loading' | translate}}</span>
                </div>

            </div>

            <!-- gdy panel wprowadzania tagów widoczny -->
            <div *ngIf="isEntryVisible" class="entry-visible">

                <!-- wprowadzanie tagow -->
                <div class="entry">
                    <input #entry type="text" class="input" [formControl]="entryControl" autofocus />
                    <a class="clear" (click)="clearAndCloseEntry()"></a>
                </div>

                <!-- podpowiedzi -->
                <ng-container *ngIf="availableTags.length >= 0">
                    <!-- block-fucus-out (onBlockFocusOut)="blockFocusOut($event)" -->
                    <div id="tag-available" [ngStyle]="{'height.px' : tagListHeight}" class="available">

                        <ng-container *ngIf="mode === 'lite' && availableTags.length === 0">

                            <!-- nie znaleziono-->
                            <div class="empty-state">
                                <div class="tags-no-items-for-filter">
                                    <div class="empty-state-image"></div>
                                    <div class="empty-state-text">{{'tags.no-found' | translate}}
                                      <span *ngIf="entryControlText">"{{entryControlText}}"</span>
                                    </div>
                                    <div class="empty-state-desc">
                                      {{'messages.change-search-criteria' | translate}}
                                    </div>
                                </div>
                            </div>

                        </ng-container>

                        <ng-container *ngIf="availableTags.length > 0">
                            <div class="last-used-tags" *ngIf="lastUsed.length > 0">
                                <label>{{'tags.last-tags' | translate}}</label>
                                <ul class="entries">
                                    <ng-container
                                        *ngFor="let tag of (lastUsedTags | sortTags:entryControlText) as _lastUsedTags">
                                        <li *ngIf="tag" id="tag-elem-{{tag.Index}}" (click)="selectTag(tag.Index)"
                                            [ngClass]="{'available-selected1' : (tag.Index === availableTagIndex)}">
                                            <span class="label">{{ tag.L }}</span>
                                            <span *ngIf="tag.Index === availableTagIndex" class="enter1"></span>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                            <div class="all-tags">
                                <label>{{'tags.all-tags' | translate}}</label>
                                <ul class="entries">
                                    <ng-container
                                        *ngFor="let tag of (filteredTags | sortTags:entryControlText) as _filteredTags">
                                        <li *ngIf="tag" id="tag-elem-{{tag.Index}}" (click)="selectTag(tag.Index)"
                                            [ngClass]="{'available-selected1' : (tag.Index === availableTagIndex)}">
                                            <span class="label">{{ tag.L }}</span>
                                            <span *ngIf="tag.Index === availableTagIndex" class="enter1"></span>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

        </div>

        <!-- zaznaczone tagi -->
        <div class="selected" *ngIf="selectedTags.length > 0">

            <div class="selected-left">
                <div class="remove-all" *ngIf="selectedTags.length > 0">
                    <a class="remove-all-link" (click)="removeAllTags()">
                    </a>
                </div>
            </div>
            <div class="selected-right">
                <ul class="entries">
                    <ng-container *ngFor="let tag of selectedTags; let i = index">
                        <li *ngIf="tag">
                            <span class="label">{{ tag.L }}</span>
                            <span class="remove" (click)="removeTag(i)">x</span>
                        </li>
                    </ng-container>
                </ul>
            </div>

        </div>

    </div>

</div>
